<section class="has-pos-rel" [class.item-swiper--is-listing-detail-page] = "isListingDetailPage">
  <p *ngIf="!items || !hasFinishedLoadingItems" class="text-center" translate="panel-message.getting-listings"></p>
  <p *ngIf="items?.length === 0 && hasFinishedLoadingItems" class="text-center">Looks like we couldn't find any suggested listings.</p>
  <ng-container *ngIf="items && items.length > 1 && hasFinishedLoadingItems">
    <i class="material-icons hide-on-mobile has-pos-abs prev md-48 no-select" role="presentation" (click)="swiper.slidePrev()">chevron_left</i>
    <i class="material-icons hide-on-mobile has-pos-abs next md-48 no-select" role="presentation" (click)="swiper.slideNext()">chevron_right</i>
  </ng-container>
  <!-- Slider main container -->
  <div class="swiper-container has-pos-rel swiper-container-horizontal">

    <!-- Additional required wrapper -->
    <div class="swiper-wrapper has-flex-align-end">
      <ng-container *ngIf="!isForCardPreview">
        <!-- If not on mobile, we set to be selected listing so that the navigation for each listing gallerys show up -->
        <div *ngFor="let listing of items; let i = index; trackBy: Listing.trackBy" class="listing swiper-slide">
          <app-listing-card [listing]="listing" (click)="itemClicked.emit()" (onFocus)="swiper.slideTo(i)"
          [isLandingPageListing]="isLandingPageListing"
          [isSelectedCard]="(swiper !== undefined && i === swiper.activeIndex) || screenSize !== SCREEN_SIZE.MOBILE_ONLY" ></app-listing-card>
        </div>
      </ng-container>
      <ng-container *ngIf="isForCardPreview">
        <ng-content></ng-content>
      </ng-container>

    </div>
    <!-- If we need pagination -->
    <!-- <div class="swiper-pagination"></div> -->
    <!-- If we need scrollbar -->
    <!-- <div class="swiper-scrollbar"></div> -->
  </div>
  <div *ngIf="items && items.length > 0 && hasFinishedLoadingItems && showItemCount" class="hide-on-tablet-up number-of-items is-flex has-flex-content-center has-flex-align-center">
    <i class="material-icons prev no-select" role="presentation" (click)="swiper.slidePrev()">chevron_left</i>
    <span class="total" translate="x-of-y" [translateParams]="{x: (swiper ? swiper.activeIndex + 1 : 1), y: totalItems || items?.length}"></span>
    <i class="material-icons next no-select" role="presentation" (click)="swiper.slideNext()">chevron_right</i>
  </div>
</section>
